import React from "react";

import backgroundImg from "../assets/visitenkarteDieWerkstatt.jpeg";
import ThirdPartyNotices from "../components/ThirdPartyNotices";

function Hero() {
  return (
    <header
      className="hero"
      style={{ backgroundImage: `url(${backgroundImg})` }}
    >
      <div className="container hero__inner">
        <h1 class="text-align-center">Impressum</h1>
      </div>
    </header>
  );
}

function Impressum() {
  return (
    <main className="section section--page">
      <div className="container">
        <h2>Die Werkstatt, Deko und Floristik, Sibille Frenger, Einzelunternehmen</h2>

        <address
          itemScope
          itemType="https://schema.org/Organization"
          style={{ fontStyle: "normal" }}
        >
          <div itemProp="name">Sibille Frenger</div>
          <div itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
            <div>
              <span itemProp="streetAddress">Arenzhofstraße 25b</span>
            </div>
            <div>
              <span itemProp="postalCode">50769</span>{" "}
              <span itemProp="addressLocality">Köln</span>
            </div>
            <div>
              <span itemProp="addressCountry">DE</span>
            </div>
          </div>

          <p>
            Telefon:{" "}
            <a href="tel:+491751952530" itemProp="telephone">
              0175&nbsp;1952530
            </a>
          </p>
          <p>
            Mail:{" "}
            <a href="mailto:die-werkstatt@gmx.eu" itemProp="email">
              die-werkstatt@gmx.eu
            </a>
          </p>
        </address>

        <p>
          Umsatzsteuer-Identifikationsnummer(n):{" "}
          <strong>DE326444028</strong>
        </p>

        <p>
          Zur Teilnahme an einem Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle sind wir nicht verpflichtet und nicht bereit.
        </p>

        <nav aria-label="Social Media" className="impressum-social">
          <a
            href="https://www.facebook.com/sibille.frenger"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            Facebook
          </a>{" "}
          ·{" "}
          <a
            href="https://www.instagram.com/sibillefrenger/?hl=de"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            Instagram
          </a>
        </nav>

        <ThirdPartyNotices />
      </div>
    </main>
  );
}

export default function App() {
  return (
    <>
      <Hero />
      <Impressum />
    </>
  );
}
